/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '../ripple/index';
import { MatPseudoCheckboxModule } from '../selection/index';
import { MatOption } from './option';
import { MatOptgroup } from './optgroup';
export class MatOptionModule {
}
MatOptionModule.decorators = [
    { type: NgModule, args: [{
                imports: [MatRippleModule, CommonModule, MatPseudoCheckboxModule],
                exports: [MatOption, MatOptgroup],
                declarations: [MatOption, MatOptgroup]
            },] },
];
/**
 * @nocollapse
 */
MatOptionModule.ctorParameters = () => [];
function MatOptionModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatOptionModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatOptionModule.ctorParameters;
}
export { MatOptionSelectionChange, MatOption } from './option';
export { MatOptgroupBase, _MatOptgroupMixinBase, MatOptgroup } from './optgroup';
//# sourceMappingURL=index.js.map